import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';

import agents from '../../api/agents';
import useUserInfo from '../../hooks/useUserInfo';

const useStyles = makeStyles(theme => ({
	root: {
		padding: 10,
		paddingTop: 40,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	title: {
		fontSize: 22,
		fontWeight: 300,
	},
	logoutButton: {
		marginTop: 30,
	}
}));

function Profile() {
	const classes = useStyles();
	const userInfo = useUserInfo();

	const handleLogout = () => {
		userInfo.handleChange({
			name: '',
			agentID: '',
			isAdmin: false,
			isAuthorized: false,
		});
		agents.signOut();
	};

	return (
		<div className={classes.root}>
			<Typography className={classes.title}>
				Hi, {userInfo.name}
			</Typography>
			<Button 
				className={classes.logoutButton}
				onClick={handleLogout}
				variant="outlined"
				color="primary"
			>
				Sign Out
			</Button>
		</div>
	);
}

export default Profile;
